"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntentType = exports.inferIntentTypeFromClientSecret = void 0;
const inferIntentTypeFromClientSecret = (clientSecret) => {
    if (clientSecret) {
        if (clientSecret.startsWith('seti'))
            return IntentType.Setup;
        if (clientSecret.startsWith('pi'))
            return IntentType.Payment;
    }
    return IntentType.None;
};
exports.inferIntentTypeFromClientSecret = inferIntentTypeFromClientSecret;
var IntentType;
(function (IntentType) {
    // Immediate payments
    IntentType[IntentType["Payment"] = 0] = "Payment";
    // Setup/confirm cards for future payments
    IntentType[IntentType["Setup"] = 1] = "Setup";
    // No card details or not being saved
    IntentType[IntentType["None"] = 2] = "None";
})(IntentType = exports.IntentType || (exports.IntentType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvX3YyL3JlZ2lzdHJhdGlvbi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFTTyxNQUFNLCtCQUErQixHQUFHLENBQUMsWUFBaUMsRUFBYyxFQUFFO0lBQy9GLElBQUksWUFBWSxFQUFFO1FBQ2hCLElBQUksWUFBWSxDQUFDLFVBQVUsQ0FBQyxNQUFNLENBQUM7WUFBRSxPQUFPLFVBQVUsQ0FBQyxLQUFLLENBQUM7UUFDN0QsSUFBSSxZQUFZLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQztZQUFFLE9BQU8sVUFBVSxDQUFDLE9BQU8sQ0FBQztLQUM5RDtJQUVELE9BQU8sVUFBVSxDQUFDLElBQUksQ0FBQztBQUN6QixDQUFDLENBQUM7QUFQVyxRQUFBLCtCQUErQixtQ0FPMUM7QUFFRixJQUFZLFVBT1g7QUFQRCxXQUFZLFVBQVU7SUFDcEIscUJBQXFCO0lBQ3JCLGlEQUFPLENBQUE7SUFDUCwwQ0FBMEM7SUFDMUMsNkNBQUssQ0FBQTtJQUNMLHFDQUFxQztJQUNyQywyQ0FBSSxDQUFBO0FBQ04sQ0FBQyxFQVBXLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBT3JCIn0=